var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFaceColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    fillOpacity: 0.52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4166 14.5002C22.4166 10.1302 18.8699 6.5835 14.4999 6.5835C10.1299 6.5835 6.58325 10.1302 6.58325 14.5002C6.58325 18.3318 9.30659 21.5222 12.9166 22.2585V16.8752H11.3333V14.5002H12.9166V12.521C12.9166 10.9931 14.1595 9.75016 15.6874 9.75016H17.6666V12.1252H16.0833C15.6478 12.1252 15.2916 12.4814 15.2916 12.9168V14.5002H17.6666V16.8752H15.2916V22.3772C19.2895 21.9814 22.4166 18.6089 22.4166 14.5002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFaceColor);
export default __webpack_public_path__ + "static/media/ic_face_color.84dfea92d03620303c6d53fc4fc961f8.svg";
export { ForwardRef as ReactComponent };